import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHeader,
  StyledItem,
  StyledItems,
  StyledWrapper
} from './MGMInfo.styled';

const MGMInfo: React.FC = () => {
  const { t } = useI18n('member-get-member');
  const { locale } = useRouter();

  let proposalUrl =
    'https://drive.google.com/file/d/1Pp_3nQyLQs4_IWYKvQYhSkwZtATc_cBp/view?usp=sharing';
  let contractUrl =
    'https://drive.google.com/file/d/1XqK7d-Gh6fUNHTfhRJo_M7uXHAapHOAE/view?usp=share_link';

  if (locale === 'es') {
    proposalUrl =
      'https://drive.google.com/file/d/1K5KZKJjF7XBZ_4eW_Op5KxMWPFYodxZ_/view?usp=sharing';
    contractUrl =
      'https://drive.google.com/file/d/1XqK7d-Gh6fUNHTfhRJo_M7uXHAapHOAE/view?usp=share_link';
  }
  if (locale === 'en') {
    proposalUrl =
      'https://drive.google.com/file/d/1Pp_3nQyLQs4_IWYKvQYhSkwZtATc_cBp/view?usp=sharing';
    contractUrl =
      'https://drive.google.com/file/d/1xLqAReXkblgjtsRP6tctRy3rWaCrCc4u/view?usp=share_link';
  }
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <Heading3 editorial>
            {t('member-get-member.know-more.title')}
          </Heading3>
          <p
            dangerouslySetInnerHTML={{
              __html: t('member-get-member.know-more.desc')
            }}
          ></p>
        </StyledHeader>
        <StyledItems>
          <StyledItem href={proposalUrl} target="_blank">
            <img
              src={getPublicPath('/images/memberGetMember/proposal-icon.svg')}
              alt=""
            />
            {t('member-get-member.know-more.proposition')}
          </StyledItem>
          <StyledItem href={contractUrl} target="_blank">
            <img
              src={getPublicPath('/images/memberGetMember/contracts-icon.svg')}
              alt=""
            />
            {t('member-get-member.know-more.contracts')}
          </StyledItem>
        </StyledItems>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default MGMInfo;
